import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  index: 0, // Set initial state of index to 0
  buttonType: {mode:"original",index:0},
};

const componentSlice = createSlice({
  name: 'component',
  initialState,
  reducers: {
    setIndex: (state, action) => {
      // console.log("Setting index to:", action.payload); // Log the payload for debugging
      state.index = action.payload; // Use `action.payload` to access the value
    },
    removeIndex: (state) => {
      state.index = 0; // Reset the index to its initial state
    },
    setButtonType: (state, action) => {
      state.buttonType = action.payload;
    }
  }
});

export const { setIndex, removeIndex, setButtonType } = componentSlice.actions;
export default componentSlice.reducer;